<template>
  <div class="h-auto">
    <request-claim
      :showRequestClaim="showRequestClaim"
      @close="showRequestClaim = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :raiseClaimCallback="raiseClaimCallback"
    ></request-claim>

    <div class="bg-white rounded-md p-3">
      <div class="flex justify-between items-center py-3">
        <p class="text-sm font-semibold">My Requests</p>
      </div>

      <el-tabs type="border-card">
        <div class="relative">
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <!-- <ve-table v-if="tableData.length" :columns="columns" :table-data="tableData" :expand-option="expandOption"
          row-key-field-name="rowKey" /> -->

          <el-tabs type="border-card">
            <div class="flex justify-between items-center p-2">
              <!-- search -->
              <input
                v-model="searchInput"
                type="search"
                placeholder="Start typing to search..."
                class="bg-gray-200 w-52 py-1 rounded-md"
              />
              <!-- search -->
              <button
                @click="showRequestClaim = true"
                class="bg-primary text-white rounded-full px-3 py-1 text-sm"
              >
                Raise Claim
              </button>
            </div>
            <div class="" v-if="tableData.length">
              <div>
                <ve-table
                  v-if="searchInput"
                  :columns="columns"
                  :table-data="filteredTableData"
                  sort-order="asc"
                  :expand-option="expandOption"
                  row-key-field-name="rowKey"
                />

                <ve-table
                  :columns="columns"
                  :tableData="tableData"
                  v-if="!searchInput.length"
                >
                </ve-table>

                <p
                  v-if="searchInput.length && filteredTableData.length === 0"
                  class="text-center py-3"
                >
                  No results
                </p>
              </div>

              <!-- Pagination -->
              <div class="table-pagination text-center mt-2">
                <el-pagination
                  v-if="tableData?.length > 0"
                  background
                  layout="prev, pager, next"
                  :total="totalCount"
                  :page-size="pageSize"
                  @current-change="handleCurrentChange"
                >
                  <!-- :current-page.sync="currentPage4" -->
                </el-pagination>
                <p v-if="tableData?.length === 0" class="text-center py-3">
                  No claims
                </p>
              </div>
            </div>

            <p v-else class="p-2 text-center text-sm w-full bg-gray-100">
              No claims found
            </p>
            <!-- Pagination -->
          </el-tabs>
        </div>
      </el-tabs>
    </div>

    <div class="bg-white m-3 rounded-md">
      <div class="flex justify-between items-center py-3">
        <p class="text-sm font-semibold">Claim History</p>
      </div>

      <div class="">
        <el-tabs type="border-card" @tab-click="(e) => setTab(e)">
          <el-tab-pane
            v-for="(tab, index) in tabs"
            :key="index"
            :label="tab.name"
          >
            <div class="" v-if="tableData2.length">
              <div class="flex justify-between items-center p-2">
                <!-- search -->
                <input
                  v-model="searchInput2"
                  type="search"
                  placeholder="Start typing to search..."
                  class="bg-gray-200 w-52 py-1 rounded-md"
                />
                <!-- search -->
              </div>

              <div>
                <ve-table
                  v-if="searchInput2"
                  :columns="columns"
                  :table-data="filteredTableData2"
                  sort-order="asc"
                />

                <ve-table
                  :columns="columns"
                  :tableData="tableData2"
                  v-if="!searchInput2.length"
                >
                </ve-table>

                <p
                  v-if="searchInput2.length && filteredTableData2.length === 0"
                  class="text-center py-3"
                >
                  No results
                </p>
              </div>
            </div>
            <p v-else class="text-center p-3 text-sm w-full bg-gray-100">
              No Claims found
            </p>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <review-claim
      :showReviewClaim="showReviewClaim"
      :closeReview="close"
      :approvalEntries="approvalEntries"
      :claimDetails="claimDetails"
      :attachmentUrl="attachmentUrl"
    ></review-claim>
  </div>
</template>

<script>
import RequestClaim from "./requestClaim.vue";
// import AttachmentsViewer from "../../utils/attachmentsViewer.vue";
import ReviewClaim from "./reviewClaim.vue";
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { Tabs, TabPane } from "element-ui";

import { mapGetters } from "vuex";
import moment from "moment";
import { formatCurrency } from "@/utils/currencyFomatter";
export default {
  name: "MyClaims",
  components: {
    RequestClaim,
    // AttachmentsViewer,
    "el-tabs": Tabs,
    "el-tab-pane": TabPane,
    Loader,
    ReviewClaim,
  },
  data() {
    return {
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      attachmentUrl: "",
      showRequestClaim: false,
      showLocCrSuccess: false,
      showAttachments: false,
      showReviewClaim: false,
      approvalEntries: null,
      claimDetails: null,
      success: null,
      create_success: null,
      loading: false,
      reload: false,
      MyLeaveTypes: [],
      currentTab: "Approved",
      selectedTab: "Approved",
      searchInput2: "",
      searchInput: "",
      MyLeaveTypeStats: [],
      activeTab: 0,
      // teamKey: 0,
      // mineKey: 1,

      tabs: [
        {
          name: "Approved",
          route: "mine",
        },

        {
          name: "Declined",
          route: "team",
        },
      ],

      balancesColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "Name",
          title: "Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Days",
          key: "Days",
          title: "Days",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) =>
            row.Days > 0 ? (
              <p class="text-green-500 font-bold text-sm">{row.Days}</p>
            ) : (
              <p class="text-red-500 font-bold text-sm">{row.Days}</p>
            ),
        },
      ],

      balances: [],

      tableData2: [],
      // Work on this
      expandOption: {
        trigger: "row",
        render: ({ row }) => {
          return (
            <table class="table-auto w-full p-2">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Line Manager</th>
                </tr>
              </thead>
              <tbody>
                {row.map(() => {
                  //console.log(row);
                  return (
                    <tr class="text-center">
                      <td>Description</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        },
        beforeExpandRowChange: ({ row, rowIndex }) => {
          // alert(JSON.stringify(row, rowIndex));
          this.getDepartments(row.Id, rowIndex);
        },
      },
      // Work on this

      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "ClaimType",
          key: "ClaimType",
          title: "Type",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <div
              class="cursor-pointer text-blue-500"
              onClick={() => {
                this.attachmentUrl = row.Attachment;
                this.approvalEntries = row.ApprovalEntries;
                this.claimDetails = row;
                this.showReviewClaim = true;
                this.showAttachments = true;
                //console.log(row)
              }}
            >
              {row.ClaimType}
            </div>
          ),
        },
        {
          field: "DateApplied",
          key: "DateApplied",
          title: "Date Applied",
          width: 160,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.DateApplied)}</p>
          ),
        },

        {
          field: "Amount",
          key: "Amount",
          title: "Amount",
          renderBodyCell: ({ row }) => formatCurrency(row.Amount),
        },

        {
          field: "Description",
          key: "Description",
          title: "Description",
          headerAlign: "left",
          align: "left",
        },

        {
          field: "Status",
          key: "g",
          title: "Status",
          renderBodyCell: ({ row }) => {
            return row.Status === "Approved" ? (
              <p class="text-green-500">Approved</p>
            ) : (
              <p>
                {row.Status === "Declined" ? (
                  <span class="text-yellow-500">Declined</span>
                ) : (
                  <span class="text-blue-500">Pending</span>
                )}
              </p>
            );
          },
        },
      ],
      columns2: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "ClaimType",
          key: "ClaimType",
          title: "Type",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Amount",
          key: "Amount",
          title: "Amount",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => formatCurrency(row.Amount),
        },
        {
          field: "DateApplied",
          key: "DateApplied",
          title: "Date Applied",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="">{this.formatDate(row?.DateApplied)}</p>
          ),
        },

        {
          field: "Description",
          key: "d",
          title: "Description",
          headerAlign: "left",
          align: "left",
        },

        {
          field: "Attachment",
          key: "Attachment",
          title: "Attachment",
          renderBodyCell: ({ row }) => {
            return (
              <button
                onClick={() => {
                  //console.log(row)
                  this.attachmentUrl = row.Attachment;
                  this.approvalEntries = row.ApprovalEntries;
                  this.claimDetails = row;
                  this.showReviewClaim = true;
                }}
                class="bg-primary text-white rounded-full px-3 py-1 text-sm"
              >
                &#128206; View
              </button>
            );
          },
        },
        {
          field: "Status",
          key: "Status",
          title: "Status",
          renderBodyCell: ({ row }) => {
            let status = "";
            switch (row.Status) {
              case "Approved":
                status = <p class="cursor-pointer text-green-500"> Approved</p>;
                break;

              case "Pending":
                status = (
                  <p
                    class="cursor-pointer text-blue-500"
                    v-if={row.Status === "Pending"}
                  >
                    Pending
                  </p>
                );
                break;
              case "Declined":
                status = (
                  <p
                    class="cursor-pointer text-red-500"
                    v-if={row.Status === "Declined"}
                  >
                    Declined
                  </p>
                );
                break;
            }
            return { status };
          },
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserType",
      "getCurrentEmployeeId",
    ]),

    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getMyClaims(this.currentTab);
    this.updateClaimList(this.selectedTab);
  },

  methods: {
    close() {
      this.showReviewClaim = false;
    },
    raiseClaimCallback(message, isError) {
      if (isError) {
        this.create_error = message;
      } else {
        this.create_success = message;
      }
      setTimeout(() => {
        this.create_error = null;

        this.create_success = null;
        this.getMyClaims(this.currentTab);
      }, 3000);
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    setTab(event) {
      const { id } = event["$el"];
      switch (id) {
        case "pane-0":
          this.selectedTab = "Approved";
          this.updateClaimList("Approved");
          break;
        case "pane-1":
          this.selectedTab = "Declined";
          this.updateClaimList("Declined");
          break;
      }
    },
    showContextMenu(row, column, event) {
      this.currentRow = row;
      this.contextMenuTop = event.clientY;
      this.contextMenuLeft = event.clientX;
      this.isContextMenuVisible = true;
      event.preventDefault();
    },

    handleCloseOnSuccess() {
      this.showRequestClaim = false;
      this.showLocCrSuccess = true;
      this.success = true;

      setTimeout(() => {
        this.showLocCrSuccess = false;
        this.success = false;
        this.getMyClaims();
      }, 3000);
    },

    formatDate(dateStr) {
      return moment(dateStr).format("DD/MM/YYYY");
    },

    getMyClaims(currentTab) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/employee/claim/me/${this.getCurrentEmployeeId}/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status == 200) {
              this.$emit("closeOnSuccess");

              this.tableData = this.filterClaims(response.data.Data, "Pending");
              this.tableData2 = this.filterClaims(response.data.Data, "All");

              if (currentTab.trim() === "Declined") {
                this.tableData2 = this.filterClaims(
                  this.tableData2,
                  "Declined"
                );
              } else if (currentTab.trim() === "Approved") {
                this.tableData2 = this.filterClaims(
                  this.tableData2,
                  "Approved"
                );
              }
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
    filterClaims(data, status) {
      if (status === "Pending") {
        return data
          .filter((claim) => claim.Status === "Pending")
          .sort((a, b) => new Date(b.DateApplied) - new Date(a.DateApplied));
      } else if (status === "Declined") {
        return data.filter((entry) => entry.Status === "Declined");
      } else if (status === "Approved") {
        return data.filter((entry) => entry.Status === "Approved");
      } else if (status === "All") {
        return data.sort(
          (a, b) => new Date(b.DateApplied) - new Date(a.DateApplied)
        );
      }
      return data;
    },

    updateClaimList(currentTab) {
      // alert(currentTab)
      this.currentTab = currentTab;
      this.getMyClaims(currentTab);
    },
  },
};
</script>

<style>
.el-tabs__item.is-top.is-active {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: "#fff" !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #fff;
}

.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #fff;
}

.el-tabs__item.is-top:hover {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
}
</style>
